import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'wislist-action',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex align-items-center btn-gap justify-content-end">
      <button
        class="manage-user-button dp-secondary-btn view-btn"
        (click)="onCellClick(rowData, 'view')"
      >
        View
      </button>
      <button
        class="manage-user-button dp-primary-btn accept-btn"
        (click)="onCellClick(rowData, 'accept')"
      >
        Accept
      </button>
      <button
        class="manage-user-button reject-btn"
        (click)="onCellClick(rowData, 'reject')"
      >
        Reject
      </button>
    </div>
  `,
  styles: [
    `
      .btn-gap {
        gap: 12px;
      }

      .reject-btn {
        background: var(--brand-destructive);
        color: var(--bg-primary);
        border-radius: 4px;
        border: none;
        font-size: 16px;
        font-weight: 600;
        font-family: var(--manrope);
        padding: 10px 8px 11px 8px;
        width: 68px;
      }

      .view-btn {
        padding: 10px 8px 11px 8px;
        width: 56px;
      }

      .accept-btn {
        padding: 10px 8px 11px 8px;
        width: 72px;
      }
    `,
  ],
})
export class WishlistActionCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  onCellClick(rowData: any, actionType: string) {
    this.cellClick.emit({ rowData, actionType });
  }
}
